import type { GlobalObjectType } from './types';

export const ALL_SUPPORTED_OBJECTS: GlobalObjectType[] = [
	'jira-issue',
	'confluence-page',
	'confluence-whiteboard',
	'identity-team',
	'townsquare-goal',
	'townsquare-project',
];
